import chroma from "chroma-js";
import moment from "moment";
import "moment/locale/nl";

export const DRAWER_WIDTH = 80;

export const logging = (string) => {
  //if (window?.DEBUG) console.log(string);
  console.log(string);
};

// Helper methods
export function getUnique(arr, comp) {
  if (arr && arr.length > 0) {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  }
  return [];
}

export function getAll(arr, key, filterValue) {
  if (arr && arr.length > 0) {
    return arr.filter((e) => e[key] === filterValue);
  }
  return [];
}

export const stringToHslColor = (string) => {
  const str = string ?? "";
  // From https://medium.com/@pppped/compute-an-arbitrary-color-for-user-avatar-starting-from-his-username-with-javascript-cd0675943b66
  const s = 30;
  const l = 55;
  let hash = 0;

  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let h = Math.abs(hash) % 360;
  return "hsl(" + h + ", " + s + "%, " + l + "%)";
};

export const getColor = (str) => {
  let hash = 0;

  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % 360;
  return chroma.scale(colors).mode("lch").colors(100)[index % 100];
};

const colors = [
  "#48bf8e",
  "#4233a6",
  "#e84fe1",
  "#7b2750",
  "#b24b29",
  "#abc093",
  "#2a6866",
  "#94da40",
  "#cf115d",
  "#e9ad6f",
  "#505b8f",
  "#ccbff5",
  "#2baad3",
  "#f09bf1",
  "#2af464",
  "#836452",
  "#d0cc36",
  "#5310f0",
  "#056e12",
  "#ff8889",
];

// Check if string is a valid url
export function isUrl(s) {
  var regexp =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  return regexp.test(s);
}

export const dayFormat = "YYYY-MM-DD";
export const timeFormat = "HH:mm";
export const dateNameFormat = "dddd D MMMM";

export const dateFormat = `${dayFormat} ${timeFormat}`;

export function formatDateName(date) {
  return moment(date).format(dateNameFormat);
}

export function getDayName(date) {
  return moment(date).format("dddd");
}

export function formatTime(time) {
  return moment(time).format(timeFormat);
}

export const getMomentDay = (value) => {
  return moment(value, dayFormat);
};

const allowedDateFormats = ["DD-MM-YYYY", "DD/MM/YYYY", "DD.MM.YYYY"];

export const getMomentDayFromInput = (value) => {
  for (let dateFormat of allowedDateFormats) {
    if (moment(value, dateFormat, true).isValid()) {
      return moment(value, dateFormat);
    }
  }
  return false;
};

export const makeItemId = () => {
  const length = 16; // generate a string of 16 chars
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const groupBy = (list, keyGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};

export const roundToTwoDecimalPlaces = (number) => {
  return Math.round((number + Number.EPSILON) * 100) / 100;
};

export const trimString = (string, length) => {
  return string.length > length ? string.substring(0, length) + "..." : string;
};

/**
 * Returns a hash code from a string
 * @param  {String} str The string to hash.
 * @return {Number}    A 32bit integer
 */
export const hashCode = (str) => {
  let hash = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    let chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return `${str}.${hash}`;
};
